define( [
	"../ajax"
], function( jQuery ) {

jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	} );
};

return jQuery._evalUrl;

} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/manipulation/_evalUrl.js
 ** module id = 486
 ** module chunks = 2
 **/